import React from "react";

import Typography from "@mui/material/Typography";

const Page404 = () => (
	<div>
		<Typography variant="h2" component="h1">
			404 SORRY, PAGE NOT FOUND
		</Typography>

		<Typography variant="h3" component="h3">
			THE PAGE YOU REQUESTED COULD NOT BE FOUND
		</Typography>
	</div>
);

export default Page404;
